import { useRef } from "react";
import { MdOutlineAttachFile } from "react-icons/md";
import { compareFileSize } from "../../../libs/generalFunctions";

import "./uploadAttachForVacation.scss";


function UploadAttachForVacation({ filesArr , setFilesArr , setError }) {

  const fileInputRef = useRef(null);

  //=====Event handler start here ========

  const handleDivClick = () => {
      fileInputRef.current.click(); 
  };


  let handleFileUpload = (e) => {
    const file = e.target.files[0];

    // Check file  Size
    if ( file && !compareFileSize( file.size , 2 ) ) {
      const error = <>حجم الملف كبير يجب ألا يتجاوز (<span style={{color:"red"}} dir="ltr">2 Mb</span>)</>;
      setError(error);
      return;
    }

    if( file ){
      setFilesArr([ ...filesArr , file ]);
    }

  };

  //=====Event handler end here ========


  return (
   <div className="vacation_upload_file_conatiner">

    <div className="add_attachment_btn" onClick={ handleDivClick } >
          <MdOutlineAttachFile  className='add_attachment_icon'/>
          <span className='add_attachment_txt' dir='rtl'>اضافة مرفق</span>
    </div>

    <input 
      type="file" 
      accept="image/*"
      ref={fileInputRef}
      id='write-enter-files'
      style={{display:"none"}}
      onChange={(e)=>{ handleFileUpload(e) }}
    />

   </div>
  )
}

export default UploadAttachForVacation;